<template>
  <div  class="col-span-6" >
    <label for="field.label" class="block 2xl:text-sm sm:text-xl font-medium leading-5 text-gray-700">
      {{field.label}}
    </label>
    <v-date-picker @change="changeValue()" v-model='dateValue' locale="es">
      <template v-slot="{ inputValue, togglePopover }">
        <div class="flex items-center">
          <button
            class="p-2 bg-gray-100 border border--200 hover:bg--200 text-gray-600 rounded-l focus:bg-gray-500 focus:text-white focus:border-gray-500 focus:outline-none"
            v-on:click.prevent="togglePopover({ placement: 'auto-start' })"
            :disabled="disabled"
            >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              class="w-4 h-4 fill-current"
              >
              <path
                d="M1 4c0-1.1.9-2 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4zm2 2v12h14V6H3zm2-6h2v2H5V0zm8 0h2v2h-2V0zM5 9h2v2H5V9zm0 4h2v2H5v-2zm4-4h2v2H9V9zm0 4h2v2H9v-2zm4-4h2v2h-2V9zm0 4h2v2h-2v-2z"
                ></path>
            </svg>
          </button>
          <input
            :value="inputValue"
            class="bg-white text-gray-700 w-full py-1 px-2 appearance-none border rounded-r focus:outline-none focus:border-gray-500"
            disabled
            />
        </div>
      </template>
    </v-date-picker>
  </div>
</template>
<script>
export default {
  name: 'date-picker-field',
  data() {
    return {
      dateValue: '',
      dependentdata: {},
      disabled: true
    }
  },
  props: {
    field: {
      type: Object,
      required: true
    },
    formdata: {
      type: Object,
      required: true
    }
  },
  created() {
    this.checkDepends()
  },
  watch: {
    dateValue: function(newValue) {
      this.$parent.updateValue(this.field.key, newValue.getTime())
    },
    formdata: {
      deep: true,
      handler: async function(newVal)  {
        if (this.field.depends !== '' && this.field.depends !== undefined) {
          if ( typeof this.dependentdata[this.field.depends] === 'object'){
            if (this.field.depends in newVal) {
              if (JSON.stringify(this.dependentdata[this.field.depends]) !== JSON.stringify(newVal[this.field.depends])) {
                this.dependentdata[this.field.depends] = JSON.parse(JSON.stringify(newVal[this.field.depends]))
                this.disabled = false
                this.$store.commit('setState', this.dependentdata)
              }
            }
          }else {
            if (this.field.depends in newVal) {
              if (this.dependentdata[this.field.depends] !== newVal[this.field.depends]) {
                this.dependentdata[this.field.depends] = JSON.parse(JSON.stringify(newVal[this.field.depends]))
                this.disabled = false
                this.$store.commit('setState', this.dependentdata)
              }
            }
          }
        }
      }
    },
  },
  methods: {
    checkDepends() {
      if (this.field.depends === undefined || this.field.depends === "") {
        this.disabled = false
      }
      this.dateValue = new Date()
    },
  }
}
</script>
